import type { IconData } from '@stacksjs/iconify-core'

export const gift: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M472 128H371.833A71.962 71.962 0 0 0 256 42.815A71.962 71.962 0 0 0 140.167 128H40a24.03 24.03 0 0 0-24 24v321.556C16 485.932 26.767 496 40 496h432c13.233 0 24-10.068 24-22.444V152a24.03 24.03 0 0 0-24-24M312 48a40 40 0 0 1 0 80h-40V88a40.045 40.045 0 0 1 40-40M160 88a40 40 0 0 1 80 0v40h-40a40.045 40.045 0 0 1-40-40M48 464V256h144v208Zm176 0V256h64v208Zm240 0H320V256h144ZM48 224v-64h416v64Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default gift
